import React from 'react';
import PropTypes from 'prop-types';
import './EmptyPlaceholder.scss';
import AppButton from '../AppButton';

export const EmptyPlaceholder = ({
    title,
    description,
    icon,
    actionText,
    onAction,
    className = '',
    actionbutton = false,
}) => {
    return (
        <div className={`emptyPlaceholder ct-flex ct-fcol ct-aiCenter ct-jcCenter ct-gap16 ${className}`}>
            <div className="emptyPlaceholderIcon ct-flexCenter ct-relative">{icon}</div>
            <div className="emptyPlaceholderInfo ct-flex ct-fcol ct-aiCenter ct-gap6">
                <div className="emptyPlaceholderTitle">{title}</div>
                <div className="emptyPlaceholderDescription">{description}</div>
            </div>
            {actionbutton && (
                <AppButton className={className} variant="xl" onClick={onAction}>
                    {actionText}
                </AppButton>
            )}
        </div>
    );
};

EmptyPlaceholder.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    icon: PropTypes.node,
    actionText: PropTypes.string,
    onAction: PropTypes.func,
    className: PropTypes.string,
    actionbutton: PropTypes.bool,
};

export default EmptyPlaceholder;
